(function () {
  'use strict';

  var GRID_ID = 'product-grid';
  var GRID_CONTAINER_ID = 'CollectionAjaxContent';
  var PAGINATION_SEL = '.pagination-wrapper';
  var MAX_PAGES = 20;

  var state = {
    cards: [],
    per_page: 24,
    section_id: '',
    total_pages: 1,
    initialized: false,
    fetching: false,
    generation: 0,
    current_page: 1,
  };

  function readMeta() {
    var el = document.getElementById(GRID_ID);
    if (!el) return null;

    return {
      section_id: el.dataset.id || '',
      per_page: parseInt(el.dataset.perPage, 10) || 24,
      total_pages: parseInt(el.dataset.totalPages, 10) || 1,
    };
  }

  function getCurrentPageFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var page = parseInt(params.get('page'), 10);
    if (isNaN(page) || page < 1) return 1;
    return page;
  }

  function buildUrl(page, sectionId) {
    var params = new URLSearchParams(window.location.search);
    params.set('page', String(page));
    params.set('section_id', sectionId);
    return window.location.pathname + '?' + params.toString();
  }

  function fetchAllPages(sectionId, totalPages) {
    var count = Math.min(totalPages, MAX_PAGES);
    var fetches = [];

    for (var i = 1; i <= count; i++) {
      fetches.push(
        fetch(buildUrl(i, sectionId)).then(function (response) {
          if (!response.ok) {
            throw new Error('HTTP ' + response.status);
          }
          return response.text();
        })
      );
    }

    return Promise.all(fetches);
  }

  function extractCards(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nodes = Array.prototype.slice.call(doc.querySelectorAll('#' + GRID_ID + ' > .grid__item'));

    return nodes.map(function (node) {
      return {
        html: node.outerHTML,
        sold_out: node.dataset.productAvailable === 'false',
      };
    });
  }

  function sortCards(cards) {
    var available = cards.filter(function (card) {
      return !card.sold_out;
    });
    var soldOut = cards.filter(function (card) {
      return card.sold_out;
    });

    return available.concat(soldOut);
  }

  function updateCount(pageNum) {
    var total = state.cards.length;
    if (!total) return;

    var start = (pageNum - 1) * state.per_page + 1;
    var end = Math.min(pageNum * state.per_page, total);
    var text = 'Mostrando ' + start + '\u2013' + end + ' de ' + total + ' produtos';

    Array.prototype.forEach.call(document.querySelectorAll('[data-collection-count]'), function (el) {
      el.textContent = text;
    });
  }

  function reinitThemeGrid() {
    if (window.theme && typeof window.theme.reinitProductGridItem === 'function') {
      window.theme.reinitProductGridItem();
    }
  }

  function renderPage(pageNum) {
    var grid = document.getElementById(GRID_ID);
    if (!grid || !state.cards.length) return;

    var start = (pageNum - 1) * state.per_page;
    var slice = state.cards.slice(start, start + state.per_page);

    if (!slice.length) return;

    grid.innerHTML = slice.map(function (card) {
      return card.html;
    }).join('');

    Array.prototype.forEach.call(grid.children, function (el, index) {
      el.style.setProperty('--animation-order', String(index + 1));
      el.style.opacity = '1';
      el.removeAttribute('reveal');
    });

    reinitThemeGrid();
  }

  function buildPagination(currentPage) {
    var wrapper = document.querySelector(PAGINATION_SEL);
    if (!wrapper) return;

    var totalPages = Math.ceil(state.cards.length / state.per_page);

    if (totalPages <= 1) {
      wrapper.innerHTML = '';
      return;
    }

    var html = '<div class="pagination">';

    if (currentPage > 1) {
      html += '<span class="prev"><a href="#" data-vs-page="' + (currentPage - 1) + '" title="Página anterior">';
      html += '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0Z"/></svg>';
      html += '<span class="icon__fallback-text">Anterior</span>';
      html += '</a></span>';
    }

    for (var i = 1; i <= totalPages; i++) {
      if (i === currentPage) {
        html += '<span class="page current">' + i + '</span>';
      } else {
        html += '<span class="page"><a href="#" data-vs-page="' + i + '">' + i + '</a></span>';
      }
    }

    if (currentPage < totalPages) {
      html += '<span class="next"><a href="#" data-vs-page="' + (currentPage + 1) + '" title="Próxima página">';
      html += '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><title>icon-chevron</title><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98Z"/></svg>';
      html += '<span class="icon__fallback-text">Próxima</span>';
      html += '</a></span>';
    }

    html += '</div>';
    wrapper.innerHTML = html;
  }

  function setUrlForPage(pageNum, replace) {
    var url = new URL(window.location.href);

    if (pageNum <= 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', String(pageNum));
    }

    if (replace) {
      history.replaceState({ vs_page: pageNum }, '', url.toString());
    } else {
      history.pushState({ vs_page: pageNum }, '', url.toString());
    }
  }

  function navigateTo(pageNum, replaceState) {
    var totalPages = Math.ceil(state.cards.length / state.per_page);
    if (pageNum < 1 || pageNum > totalPages) return;

    state.current_page = pageNum;
    renderPage(pageNum);
    buildPagination(pageNum);
    updateCount(pageNum);
    setUrlForPage(pageNum, !!replaceState);

    var container = document.getElementById(GRID_CONTAINER_ID);
    if (container && !replaceState) {
      var top = container.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
  }

  function onPaginationClick(event) {
    var link = event.target.closest('a[data-vs-page]');
    if (!link) return;

    event.preventDefault();

    var page = parseInt(link.dataset.vsPage, 10);
    if (isNaN(page)) return;

    navigateTo(page, false);
  }

  function attachPaginationListeners() {
    var wrapper = document.querySelector(PAGINATION_SEL);
    if (!wrapper) return;

    wrapper.removeEventListener('click', onPaginationClick);
    wrapper.addEventListener('click', onPaginationClick);
  }

  function reorderSinglePageDom() {
    var grid = document.getElementById(GRID_ID);
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid__item'));
    var available = cards.filter(function (node) {
      return node.dataset.productAvailable !== 'false';
    });
    var soldOut = cards.filter(function (node) {
      return node.dataset.productAvailable === 'false';
    });

    available.concat(soldOut).forEach(function (node) {
      grid.appendChild(node);
    });

    reinitThemeGrid();
  }

  function initVirtualSort() {
    var meta = readMeta();
    if (!meta || !meta.section_id) return;

    state.section_id = meta.section_id;
    state.per_page = meta.per_page;
    state.total_pages = meta.total_pages;

    if (state.total_pages <= 1) {
      reorderSinglePageDom();
      state.initialized = true;
      return;
    }

    var generation = ++state.generation;
    state.fetching = true;
    state.initialized = false;

    var grid = document.getElementById(GRID_ID);
    if (grid) {
      grid.style.visibility = 'hidden';
    }

    fetchAllPages(state.section_id, state.total_pages)
      .then(function (pagesHtml) {
        if (generation !== state.generation) return;

        var allCards = [];
        pagesHtml.forEach(function (html) {
          allCards = allCards.concat(extractCards(html));
        });

        state.cards = sortCards(allCards);
        state.fetching = false;
        state.initialized = true;

        var initialPage = getCurrentPageFromUrl();
        var totalVirtualPages = Math.max(1, Math.ceil(state.cards.length / state.per_page));
        if (initialPage > totalVirtualPages) initialPage = totalVirtualPages;

        navigateTo(initialPage, true);
        attachPaginationListeners();

        if (grid) {
          grid.style.visibility = '';
        }
      })
      .catch(function (error) {
        if (generation !== state.generation) return;

        state.fetching = false;
        if (grid) {
          grid.style.visibility = '';
        }

        console.warn('[d-collection-sort-availability] fetch error, fallback to DOM reorder', error);
        reorderSinglePageDom();
      });
  }

  var debounceTimer = null;

  function watchForUpdates() {
    var container = document.getElementById(GRID_CONTAINER_ID);
    if (!container) return;

    var observer = new MutationObserver(function (mutations) {
      var gridChanged = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return false;
          if (node.id === GRID_ID) return true;
          if (typeof node.querySelector === 'function' && node.querySelector('#' + GRID_ID)) return true;
          return false;
        });
      });

      if (!gridChanged || state.fetching) return;

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        state.cards = [];
        state.initialized = false;
        initVirtualSort();
      }, 150);
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  window.addEventListener('popstate', function (event) {
    if (!state.initialized || !event.state || !event.state.vs_page) return;

    var page = parseInt(event.state.vs_page, 10);
    if (isNaN(page)) return;

    renderPage(page);
    buildPagination(page);
    updateCount(page);
    state.current_page = page;
  });

  function boot() {
    if (!document.getElementById(GRID_ID)) return;

    initVirtualSort();
    watchForUpdates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
